import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { GeneralMessage, TypeIconCompare} from '../../model/device/message.model';
import {MessageTypeCompare} from '../../constants/const';

@Component({
  selector: 'app-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss']
})
export class NotificationMessageComponent implements OnInit {
  typeIcons = TypeIconCompare;
  messageType = MessageTypeCompare;
  message = '';
  containsInnerHtml = false;
  constructor(@Inject(MAT_DIALOG_DATA) public notificationMessage: GeneralMessage,
              private dialogRef: MatDialogRef<GeneralMessage>) { }

  ngOnInit(): void {
    this.containsInnerHtml = this.notificationMessage.containsInnerHtml ?? false;
    this.message = String(this.notificationMessage.textToShow);
  }
  closeModal(): void {
    this.dialogRef.close();
  }
  okModal(): void{
    this.dialogRef.close({...this.notificationMessage, wasOk: true} );
  }
}
